import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BalanceReportFilterForm, PackageExpirationDateForm, ReviewsReportFilterForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { BalanceReport, ReviewsReport } from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class BalanceReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getBalanceReport(filter: BalanceReportFilterForm): Observable<DataWithPagination<BalanceReport[]>> {
    return this.baseAPI.post(Constants.GET_BALANCE_REPORT, filter).pipe(
      map((res) => {
        const data: DataWithPagination<BalanceReport[]> = {
          data: this.mapper.fromListJson(BalanceReport, res.items),
          count: res.count,
        };
        return data;
      })
    );
  }

  changePackageExpirationDate(packageExpiration: PackageExpirationDateForm): Observable<string> {
    const body = {
      expiry_date: packageExpiration.expireDate,
      studentId: packageExpiration.studentId,
      studentPackageId: packageExpiration.studentPackageId,
    };
    return this.baseAPI.post(Constants.CHANGE_PACKAGE_EXPIRATION_DATE, body).pipe(map((res) => res.message));
  }

  setPackageAsExpired(packageCancel: PackageExpirationDateForm): Observable<string> {
    return this.baseAPI.post(Constants.MARK_PACKAGE_AS_CONSUMED_API_UEL, packageCancel).pipe(map((res) => res.message));
  }
}
